var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGXgacEld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-570 -790) translate(570 790)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    fill: "#32239B",
    stroke: "#FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M21.576 8.379V2.923c0-.576-.462-1.043-1.03-1.043H4.03C3.461 1.88 3 2.347 3 2.923v18.913c0 .577.461 1.044 1.03 1.044h16.515c.569 0 1.03-.467 1.03-1.044V8.38zM28.208 4.887L21.576 8.38v8.001l6.632 3.492c.361.19.792-.075.792-.487V5.374c0-.411-.431-.676-.792-.487z",
    transform: "translate(15 18.12)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EE3D85",
    strokeWidth: 3,
    d: "M0 0.88L25 25.88",
    transform: "translate(15 18.12)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGXgacEld);
export default __webpack_public_path__ + "static/media/gXgacELD.0439a018da4b6296a7d93bc484dcaf07.svg";
export { ForwardRef as ReactComponent };